import React from "react";
import styles from "./ResultsByTest.module.css";
import type { testScore } from "@/features/dashboard/types.api";
import Card from "@/components/common/card/Card";

const ResultsByTestCard: React.FC<{ tests: testScore[] }> = ({ tests }) => {
    if (!tests || tests.length === 0) {
        return (
            <Card title="Resultados por prueba" icon="📊" id="test-results">
                <p>No hay datos de pruebas disponibles.</p>
            </Card>
        );
    }

    return (
        <Card title="Resultados por prueba" icon="📊" id="test-results">
            <div className={styles["areas-grid"]}>
                {tests.map((test, index) => (
                    <div key={index} className={styles["area-item"]}>
                        <div className={styles["area-score"]}>{test.score}</div>
                        <div className={styles["area-name"]}>{test.name}</div>
                    </div>
                ))}
            </div>
        </Card>
    );
};

export default ResultsByTestCard;
